webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Map_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_TileLayer_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layers_TileLayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layers_TileLayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Marker_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Marker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Marker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Popup_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Popup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Popup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tooltip_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Tooltip_vue__);







var plugin = {};

plugin.install = function (Vue, store) {
  var moduleName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'VL';

  store.registerModule(moduleName, __WEBPACK_IMPORTED_MODULE_0__vuex__["a" /* default */]);

  if (store.state.hasOwnProperty(moduleName) === false) {
    console.error('vue-leaflet module is not correctly initialized. Please check the module name:', moduleName);
  }

  Vue.component('LMap', __WEBPACK_IMPORTED_MODULE_1__components_Map_vue___default.a);
  Vue.component('LTilelayer', __WEBPACK_IMPORTED_MODULE_2__components_layers_TileLayer_vue___default.a);
  Vue.component('LMarker', __WEBPACK_IMPORTED_MODULE_3__components_Marker_vue___default.a);
  Vue.component('LPopup', __WEBPACK_IMPORTED_MODULE_4__components_Popup_vue___default.a);
  Vue.component('LTooltip', __WEBPACK_IMPORTED_MODULE_5__components_Tooltip_vue___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  module: __WEBPACK_IMPORTED_MODULE_0__vuex__["a" /* default */],
  plugin: plugin,
  LMap: __WEBPACK_IMPORTED_MODULE_1__components_Map_vue___default.a,
  LTilelayer: __WEBPACK_IMPORTED_MODULE_2__components_layers_TileLayer_vue___default.a,
  LMarker: __WEBPACK_IMPORTED_MODULE_3__components_Marker_vue___default.a,
  LPopup: __WEBPACK_IMPORTED_MODULE_4__components_Popup_vue___default.a,
  LTooltip: __WEBPACK_IMPORTED_MODULE_5__components_Tooltip_vue___default.a
});

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_leaflet_dist_leaflet_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      zoom: 2,
      center: [50.00, -30.0],
      offMapMarker: [52.908902047770255, 163.82812500000003],
      markers: [{ coords: [49.0378679453, -62.2265625],
        heading: "1. Multistem hazel - Bracken Moorland",
        content: "Hazel (Corylus avellana) is an understory shrub that grows in the dappled shade of taller trees.  This example has been coppiced, a traditional process where a tree is cut back to encourage the regrowth of many smaller stems, which were traditionally used in furniture making and thatched roofing.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/multistem-hazel/' target='_blank'>View Resource ></a>" }, { coords: [45.0890355648, -2.98828125],
        heading: "2. Wild Strawberry - Bracken Moorland",
        content: "The wild or woodland strawberry (Fragaria vesca) looks like a smaller version of the cultivated variety. The population of this species is now increasing here after selected trees were felled and the shrub layer cleared a few years ago, allowing more light to reach the ground. ",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/wild-strawberry/' target='_blank'>View Resource ></a>" }, { coords: [77.3125199382, 2.109375],
        heading: "3. Tree survey, Wood 1: sweet chestnut",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-1-sweet-chestnut/' target='_blank'>View Resource ></a>" }, { coords: [48.3416461724, -46.0546875],
        heading: "4. Tangled vegetation - Dan Sumption",
        content: "To succeed among all the other vegetation bluebell bulbs (Hyacinthoides non-scripta) must produce their leaves early in the year, before the deciduous tree canopy closes over and light levels drop.  This successful strategy means that bluebells are the dominant plant in many areas of the wood.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tangled-vegetation/' target='_blank'>View Resource ></a>" }, { coords: [45.583289756, -36.9140625],
        heading: "5. Beech and sweet chestnut - Dan Sumption",
        content: "This part of the wood is a mix of sweet chestnut (Castanea sativa), on the left, and beech (Fagus sylvatica), the lower branches of which are seen.  Neither of these trees are native to northern Britain: sweet chestnut was introduced from southern Europe, whereas beech originally grew only in southern Britain.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/beech-sweet-chestnut/' target='_blank'>View Resource ></a>" }, { coords: [48.3416461724, -63.80859375],
        heading: "6. Clearing with coppiced hazel - Graham Turnbull",
        content: "This hazel (Corylus avellana) has been coppiced, leaving just three stems or 'poles' to continue growing.  These can be bent over and pinned to the ground, where they will take root and form the next generation of hazel trees. The 'layering' technique positions new saplings 5ft from the parent tree, helping to suppress competition from brambles (Rubus fruticosus).",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/clearing-coppiced-hazel/' target='_blank'>View Resource ></a>" }, { coords: [46.3165841818, -2.4609375],
        heading: "7. Clearing with regrowth - Graham Turnbull",
        content: "This clearing was created to allow woodland plants, the seeds of which remain dormant in the soil for many decades, the chance to reestablish.  It takes regular maintenance by volunteers to prevent brambles (Rubus fruticosus) and tree saplings from overshadowing them.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/clearing-with-regrowth/' target='_blank'>View Resource ></a>" }, { coords: [0, -33.75],
        heading: "8. Honeysuckle - Bracken Moorland",
        content: "Sweet-smelling honeysuckle (Lonicera periclymenum) is abundant in this part of the wood and is especially fragrant at night to attract pollinating moths.  Honeysuckle will only bloom abundantly in brighter locations and may fail to flower in deep shade.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/honeysuckle/' target='_blank'>View Resource ></a>" }, { coords: [54.0077687619, -13.271484375],
        heading: "9. Clearing with bluebells - Ian Wilshaw",
        content: " Bluebells (Hyacinthoides non-scripta) are the dominant plant species in this large clearing. One of the reasons they do so well here is because they are encircled by a 'dead hedge'. This not only protects plants and tree saplings from being trampled, but it also provides an additional habitat for insects and other small animals.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/clearing-with-bluebells/' target='_blank'>View Resource ></a>" }, { coords: [48.2246726496, -27.94921875],
        heading: "10. Nurse log - Rebecca Gransbury",
        content: "Where trees have been felled to creating a clearing in the canopy, they are sometimes left in situ because a decaying tree makes a great habitat.  Often referred to as nurse logs, many plants, fungi and animals benefit from the shade, shelter and the nutrients they provide.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/nurse-log/' target='_blank'>View Resource ></a>" }, { coords: [49.4966745275, -13.798828125],
        heading: "11. Sweet chestnut at woodland edge - Richard Kedward",
        content: "Because sweet chestnut (Castanea sativa) grows relatively fast it can often look older than its true age, especially when compared with slow growing oak (Quercus spp.)  This specimen measures 4.1m around the girth and yet it is probably no more than 150 years old.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-woodland-edge/' target='_blank'>View Resource ></a>" }, { coords: [62.7144621015, -15.64453125],
        heading: "12. Charcoal Burner - Sally Goldsmith",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/charcoal-burner/' target='_blank'>View Resource ></a>" }, { coords: [18.5629474429, -77.34375],
        heading: "13. Bird song - Sue Unwin",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/bird-song/' target='_blank'>View Resource ></a>" }, { coords: [56.8008783123, -10.810546875],
        heading: "14. Tree survey, Wood 2: larch",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-2-larch/' target='_blank'>View Resource ></a>" }, { coords: [34.7416124988, -96.6796875],
        heading: "15. Veteran rowan - Fran Halsall",
        content: "Although this particular rowan, or mountain ash, (Sorbus aucuparia) is not a large tree, compared with its taller neighbours, it is still potentially quite old.  Because it is such a slow-growing tree a trunk girth of just 1.5m makes it a likely veteran, an assessment supported by the presence of emerging basal shoots.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/veteran-rowan/' target='_blank'>View Resource ></a>" }, { coords: [58.5395947666, -41.572265625],
        heading: "16. Veteran beech - Fran Halsall",
        content: "There are several large beeches (Fagus sylvatica) in the woods and at 3.9m around the girth, this is one of the biggest. Although the only way to truly know a tree's age is to count its rings, a rough estimate would place this beech between 200 and 300 years old.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/veteran-beech/' target='_blank'>View Resource ></a>" }, { coords: [65.3668368923, -11.6015625],
        heading: "17. Twisted hornbeam - Fran Halsall",
        content: "Hornbeam (Carpinus betulus) was introduced to northern Britain from the south, like the beech (Fagus sylvatica) it so closely resembles.  It was planted here for both its durable timber and for its attractive ornamental qualities.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/twisted-hornbeam/' target='_blank'>View Resource ></a>" }, { coords: [84.3542995777, -37.79296875],
        heading: "18. Sweet chestnut and scots pine - Fran Halsall",
        content: "Large trees usually stay out of each other's way, however this Scot's pine (Pinus sylvestris), an evergreen conifer, is being embraced by a sweet chestnut (Castanea sativa). Both species were extensively planted in the woods during the 19th century, when coppicing was abandoned in favour of producing large timber for industry.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-scots-pine/' target='_blank'>View Resource ></a>" }, { coords: [-15.7076627696, -40.60546875],
        heading: "19. Veteran coppiced oak - Fran Halsall",
        content: "It is almost impossible to provide an accurate age for a coppiced tree, however this oak (Quercus spp.) offers a few clues. The height of the coppice stool - the base from which the two stems grew - indicates multiple cycles of cutting and regrowth. It has then had many decades to regrow into a full-sized tree. 300 - 400 years old is a reasonable guestimate.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/veteran-coppiced-oak/' target='_blank'>View Resource ></a>" }, { coords: [77.5231217902, 9.4921875],
        heading: "20. Veteran oak - Fran Halsall",
        content: "Trunk girth alone can reveal only so much about this oak's (Quercus spp.) age.  Its environment has to be considered, as a tree located inside shady woodland will grow much more slowly than one in a sunny spot.  At 3.5m, and surrounded by mature woodland, this oak is possibly 300 years old.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/veteran-oak/' target='_blank'>View Resource ></a>" }, { coords: [51.7814356044, -18.984375],
        heading: "21. Slumped beech - Fran Halsall",
        content: "With its slumped shape and 3.75m girth this is a particularly striking beech (Fagus sylvatica). It is possible that it is a 'lapsed' coppice, although there could be other natural causes that would account for the unusual growth habit.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/slumped-beech/' target='_blank'>View Resource ></a>" }, { coords: [83.0687741347, -39.111328125],
        heading: "22. Multistem hazel- Sue Unwin",
        content: "Providing both nuts and fast-growing timber, hazel (Corylus avellana) was important to those who once made their living from the woods.   Coppicing encourges the growth of more stems and, when done at regular intervals, prolongs hazel's lifespan from 80 to two hundred years or more.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/multistem-hazel-2/' target='_blank'>View Resource ></a>" }, { coords: [65.2934678011, 47.724609375],
        heading: "23. Common beech - Sue Unwin",
        content: "Beech (Fagus sylvatica) is recognisable by its grey, often smooth, bark and its dominating stature.  These trees have shallow roots and their prominence at the surface is another identifying characteristic.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/common-beech/' target='_blank'>View Resource ></a>" }, { coords: [51.727028157, -12.919921875],
        heading: "24. Sweet chestnut and clearing - Dan Sumption",
        content: "A large two-stemmed coppiced sweet chestnut (Castanea sativa) frames the view into a large woodland clearing.   This species was introduced into these woods approximately 190 years ago as a fast growing alternative to oak.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-clearing/' target='_blank'>View Resource ></a>" }, { coords: [73.4033376629, -31.728515625],
        heading: "25. Wood anemone - Nadine Grundy",
        content: "Wood anemone (Anemone nemorosa) is among the earliest spring flowers, appearing in March - April, and spreading out to form a carpet that thrives in light shade. This is a five-petalled flower, six or seven petals are more common.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/wood-anemone/' target='_blank'>View Resource ></a>" }, { coords: [56.0720354718, -10.72265625],
        heading: "26. Collier's pond - Bracken Moorland",
        content: "The Collier's Pond was created on the site of an abandoned ganister mine in 2009 and quickly became an important habitat. Beyond the hazel screen or 'hurdle', pendulous sedge (Carex pendula) and yellow-flowered flag iris (Iris pseudacorus) thrive on the damp pond margins.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/colliers-pond/' target='_blank'>View Resource ></a>" }, { coords: [81.1609960899, 1.142578125],
        heading: "27. Common beech - Lynne Chapman",
        content: "As with all trees, an increasingly gnarled look is a sign of greater age; even smooth-barked beech (Fagus sylvatica) is no exception.  Other signs to look for include:  crevices, dead wood in the crown, and plants/fungi growing on the tree.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/common-beech-2/' target='_blank'>View Resource ></a>" }, { coords: [58.5854356912, -23.02734375],
        heading: "28. Tree survey, Wood 2: oak",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-2-oak/' target='_blank'>View Resource ></a>" }, { coords: [55.6279959543, -13.798828125],
        heading: "29. Tree survey, Wood 2: English oak",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-2-english-oak/' target='_blank'>View Resource ></a>" }, { coords: [61.7731228645, -11.337890625],
        heading: "30. Tree survey, Wood 2: Scot's pine",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-2-scots-pine/' target='_blank'>View Resource ></a>" }, { coords: [41.705728515237524, -91.23046875],
        heading: "31. Sweet chestnut and oak woodland - Daniel Blackburn",
        content: "The largest trees in this area of the wood are all sweet chestnut (Castanea sativa), which easily outgrow neighbouring oaks (Quercus spp.) Looking northeast along the main path there appears to be a mound of grass on the left; this is actually a large patch of greater wood rush (Luzula sylvatica) an evergreen plant that colonises shady locations.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-oak-woodland/' target='_blank'>View Resource ></a>" }, { coords: [37.09023980307208, -95.537109375],
        heading: "32. Oak and sweet chestnut woodland - Daniel Blackburn",
        content: "Looking southwest from the main path, this area is dominated by sweet chestnut (Castanea sativa) and oak (Quercus spp.).  At this point the topography abruptly changes; the ground drops away over a sandstone escarpment before reaching the Limb Brook more than 20 metres below.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/oak-sweet-chestnut-woodland/' target='_blank'>View Resource ></a>" }, { coords: [12.983147716796578, -64.86328125000001],
        heading: "33. Hairy curtain crust - Jack Brodie",
        content: "Hairy curtain crust fungus (Stereum hirsutum)is common in Britain and Ireland, and is widely distributed throughout the world.  Visible year-round, it is frequently mistaken for turkeytail fungus (Trametes versicolor) although it can be distinguished by its hairy upper surfaces. This species is particularly associated with the rotting trunks and branches of oak and beech.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/hairy-curtain-crust/' target='_blank'>View Resource ></a>" }, { coords: [30.14512718337613, -44.82421875000001],
        heading: "34. Yellow sulphur tuft - Jack Brodie",
        content: "Yellow sulphur tuft (Hypholoma fasciculare) are a common species found in both deciduous and coniferous woods from late summer onwards.  With their bright colour and their habit of growing in crowded colonies they are easy to spot, however do not be tempted to touch them as they are poisonous.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/yellow-sulphur-tuft/' target='_blank'>View Resource ></a>" }, { coords: [36.59788913307022, -30.849609375000004],
        heading: "35. Bleeding broadleaf crust - Jack Brodie",
        content: "Bleeding broadleaf crust (Stereum rugosum) is very common, is visible throughout the year and yet is easily overlooked due to its unassuming appearance.  The primary means of identification is that it bleeds red when scratched.  Otherwise it is most typically associated with decaying hazel.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/bleeding-broadleaf-crust/' target='_blank'>View Resource ></a>" }, { coords: [24.5271348225978, -50.44921875000001],
        heading: "36. Sweet chestnut cupule - Jack Brodie",
        content: "Edible sweet chestnut (Castanea sativa) is easily distinguished from toxic horse chestnut (Aesculus hippocastanum), aka conker, as the casing or 'cupule' is covered with flexible spines that are quite different from the conker's spines. The sweet chestnuts found on the woodland floor contain two or three nuts, unlike the single large nut associated with commercially grown cultivars.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-cupule/' target='_blank'>View Resource ></a>" }, { coords: [77.87881372624746, 10.195312500000002],
        heading: "37. Large veteran beech - Fran Halsall",
        content: "At 4.45m around the girth this is one of, if not the largest, beech (Fagus sylvatica) in Ecclesall Woods.  If it grew up surrounded by woodland it could be anywhere between 250 and 350 years old, dependent upon how much competition it faced.  This means that it pre-dates the widespread introduction of beech into the woods approximately 190 years ago.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/large-veteran-beech/' target='_blank'>View Resource ></a>" }, { coords: [68.17155518732503, 15.117187500000002],
        heading: "38. Tree survey, Wood 2: beech",
        content: "",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/tree-survey-wood-2-beech-2/' target='_blank'>View Resource ></a>" }, { coords: [44.08758502824518, -89.47265625],
        heading: "39. Sweet chestnut stump - Scarlett Howie",
        content: "Sweet chestnuts (Castanea sativa) were introduced into the woods because they are a fast-growing source of timber. The resprouting shoots found on this decaying stump are testament to their vigour. Rotting tree stumps provide an important habitat for woodland invertebrates and fungi.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-stump/' target='_blank'>View Resource ></a>" }, { coords: [48.516604348867475, -64.59960937500001],
        heading: "40. Ash tree - Cailen Howie",
        content: "Ash (Fraxinus excelsior) occurs frequently in this part of the wood, where an area of lapsed hazel coppice, and associated plants, is being restored. Ash, unlike some broadleaf trees, has an open crown that allows plenty of sunshine to reach the understory, and it's light leaf fall is quick to decompose meaning that it does not smother the groundflora emerging the following spring.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/ash-tree/' target='_blank'>View Resource ></a>" }, { coords: [48.63290858589535, -69.16992187500001],
        heading: "41. Hawthorn - Cailen Howie",
        content: "This hawthorn (Crataegus monogyna) is part of a hedge forming an old field boundary. Hawthorn is a difficult tree to accurately age; their slow growth habit means they rarely reach an impressive girth. A 50 year old hedge may look similar to one that is three times the age, as hard pruning rejuvenates the tree prolonging it's natural lifespan.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/hawthorn/' target='_blank'>View Resource ></a>" }, { coords: [77.76758238272801, -21.357421875000004],
        heading: "42. Broad buckler fern - Christine Thuring",
        content: "The broad buckler fern (Dryopteris dilatata) is a common sight in the woods. Its wide triangular leaves grow up to 100cm in length and it can be distinguished from similar deciduous ferns by the noticeable spacing between the individual leaflets arranged along the stem. Usually found growing in shade, this fern requires moist soils and/or deep leaf litter.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/broad-buckler-fern/' target='_blank'>View Resource ></a>" }, { coords: [79.0049621603135, -30.849609375000004],
        heading: "43. Suckering sweet chestnut - Fran Halsall",
        content: "Suckers' or basal shoots emerge from the bottom of a sweet chestnut (Castanea sativa). Suckering is a response to disease affecting a tree's vigour or to intensive pruning, aka 'topping', where the tree's crown is removed. In each case the tree is attempting to regenerate from the base.  When occurring naturally it can be an indicator of significant age and is a characteristic of veteran trees.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/suckering-sweet-chestnut/' target='_blank'>View Resource ></a>" }, { coords: [68.17155518732503, 9.404296875000002],
        heading: "44. Beech grove  - Fran Halsall",
        content: "This 'grove' is typical of the way beech (Fagus sylvatica) asserts itself within the woods. Their dense crowns cast deep shade; their roots hungrily extract nutrients and moisture from the soil; and their fallen leaves are slow to decompose.  Between these factors they suppress most other groundflora, creating swathes of ground left bare apart from a carpet of leaves.",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/beech-grove/' target='_blank'>View Resource ></a>" }, { coords: [48.40003249610685, -44.03320312500001],
        heading: "45. Sweet chestnut coppice and pollard",
        content: "This sweet chestnut (Castanea sativa) has been coppiced, producing three main trunks, and later pollarded, creating multiple shoots where cut. Sadly this historically interesting specimen is succumbing to Phytophora, a fungal infection recognisable by dark stains on the bark, whose mycelium 'girdle' the tree until it can no longer respire or circulate nutrients. ",
        link: "<a href='http://sheffieldwoodlandconnections.co.uk/sweet-chestnut-coppice-and-pollard/' target='_blank'>View Resource ></a>" }],
      minZoom: 2,
      maxZoom: 4,
      url: '/static/assets/tiles/none/{z}/{x}/{y}.png',
      attribution: 'SpringBoot-Map',
      title: 'SpringBoot-Map',
      opacity: 1,
      draggable: true,
      attributionControl: false
    };
  },

  methods: {
    zoomend: function zoomend() {
      console.log(1);
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);





var events = ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove', 'contextmenu', 'focus', 'blur', 'preclick', 'load', 'unload', 'viewreset', 'movestart', 'move', 'moveend', 'dragstart', 'drag', 'dragend', 'zoomstart', 'zoomend', 'zoomanim', 'zoomlevelschange', 'resize', 'autopanstart', 'layeradd', 'layerremove', 'baselayerchange', 'overlayadd', 'overlayremove', 'locationfound', 'locationerror', 'popupopen', 'popupclose'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: {
      type: String,
      default: 'map',
      require: true
    },
    center: {
      custom: true,
      default: undefined,
      require: true
    },
    zoom: {
      type: Number,
      default: undefined,
      require: true
    },
    maxBounds: {
      custom: true,
      default: null
    },
    minZoom: {
      type: Number,
      default: undefined
    },
    maxZoom: {
      type: Number,
      default: undefined
    },
    attributionControl: {
      type: Boolean,
      default: true
    },
    zoomControl: {
      type: Boolean,
      default: true
    }
  },

  mounted: function mounted() {
    var _this = this;

    var options = {
      center: this.center,
      zoom: this.zoom,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      maxBounds: this.maxBounds,
      attributionControl: this.attributionControl,
      zoomControl: this.zoomControl
    };

    this.mapReady({ name: this.id, options: options });
    events.forEach(function (event, index) {
      _this.addEvent({ event: event, func: function func(ev) {
          _this.$emit(event, ev);
        } });
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['mapReady', 'addEvent', 'locate']))
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);






var events = ['click', 'dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu', 'dragstart', 'drag', 'dragend', 'move', 'add', 'remove', 'popupopen', 'popupclose', 'tooltipopen', 'tooltipclose'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    position: {
      type: Array
    },
    icon: {
      custom: false,
      default: __webpack_require__(77)
    },
    iconShadow: {
      custom: false,
      default: __webpack_require__(78)
    },
    iconRetina: {
      custom: false,
      default: __webpack_require__(76)
    },
    draggable: {
      type: Boolean,
      custom: true,
      default: false
    },
    visible: {
      type: Boolean,
      custom: false,
      default: true
    },
    opacity: {
      type: Number,
      default: 1
    },
    title: {
      type: String
    }
  },

  mounted: function mounted() {
    this.fixImageUrl();

    var options = {
      draggable: this.draggable,
      opacity: this.opacity,
      title: this.title,
      visible: this.title
    };

    var marker = this.$marker = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.marker(this.position, options);

    this.$nextTick(function () {
      var _this = this;

      console.log('tick..');
      this.addLayer(marker);
      events.forEach(function (event) {
        marker.on({ event: event, func: function func(ev) {
            _this.$emit(event, ev);
          } });
      });
    });

    marker.on('dragend', function () {
      console.log(marker.getLatLng());
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(["addLayer"]), {
    fixImageUrl: function fixImageUrl() {
      delete __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Icon.Default.prototype._getIconUrl;
      __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Icon.Default.mergeOptions({
        iconRetinaUrl: this.iconRetina,
        iconUrl: this.icon,
        shadowUrl: this.iconShadow
      });
    },

    dragEnd: function dragEnd() {
      console.log('hello');
    }
  })

});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);






var events = ['add', 'remove', 'popupopen', 'popupclose', 'tooltipopen', 'tooltipclose'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    content: {
      type: String,
      custom: true,
      default: ''
    },
    heading: {
      type: String,
      custom: true,
      default: ''
    },
    link: {
      type: String,
      custom: true,
      default: ''
    },
    latlng: {
      type: Array
    }
  },

  mounted: function mounted() {
    if (this.latlng) {
      var popup = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.popup().setLatLng(this.latlng).setContent('<h3>' + this.heading + '</h3><p>' + this.content + '</p><p>' + this.link + '</p>');

      this.$nextTick(function () {
        var _this = this;

        this.openPopup(popup);
        events.forEach(function (event) {
          popup.on({ event: event, func: function func(ev) {
              _this.$emit(event, ev);
            } });
        });
      });
    } else {
      this.$nextTick(function () {
        this.$parent.$marker.bindPopup('<h3>' + this.heading + '</h3><p>' + this.content + '</p><p>' + this.link + '</p>').openPopup();
      });
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['openPopup']))
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);





var events = ['add', 'remove', 'popupopen', 'popupclose', 'tooltipopen', 'tooltipclose'];

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    content: {
      type: String,
      custom: true,
      default: ''
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.$parent.$marker.bindTooltip(this.content).openTooltip();
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys_MapKey_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys_MapKey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__keys_MapKey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_WildFlowerKey_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_WildFlowerKey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__keys_WildFlowerKey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys_BluebellKey_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys_BluebellKey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keys_BluebellKey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_TreeKey_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_TreeKey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__keys_TreeKey_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['key', 'keyString', 'borderColour'])),

  data: function data() {
    return {
      open: false
    };
  },


  components: {
    MapKey: __WEBPACK_IMPORTED_MODULE_3__keys_MapKey_vue___default.a,
    WildFlowerKey: __WEBPACK_IMPORTED_MODULE_4__keys_WildFlowerKey_vue___default.a,
    BluebellKey: __WEBPACK_IMPORTED_MODULE_5__keys_BluebellKey_vue___default.a,
    TreeKey: __WEBPACK_IMPORTED_MODULE_6__keys_TreeKey_vue___default.a
  },

  methods: {
    show: function show(el, done) {
      __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default()(el, { width: "220px" }, { duration: 300, easing: "linear", complete: done });
    },
    hide: function hide(el, done) {
      __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default()(el, { width: "0" }, { duration: 300, easing: "linear", complete: done });
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var map = 'none';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      map: map
    };
  },


  methods: {
    change: function change(m) {
      this.map = m;
      this.$emit('map', this.map);
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {



/***/ }),
/* 28 */
/***/ (function(module, exports) {



/***/ }),
/* 29 */
/***/ (function(module, exports) {



/***/ }),
/* 30 */
/***/ (function(module, exports) {



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_TileSelect_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_TileSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__custom_TileSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_Key_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_Key_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__custom_Key_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tilelayer: __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer(this.url, { attribution: this.attribution }),
      key: __WEBPACK_IMPORTED_MODULE_4__custom_Key_vue___default.a
    };
  },


  props: {
    url: {
      type: String
    },
    attribution: {
      type: String
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.addLayer(this.tilelayer);
    });
  },


  components: {
    LTileSelect: __WEBPACK_IMPORTED_MODULE_3__custom_TileSelect_vue___default.a,
    LKey: __WEBPACK_IMPORTED_MODULE_4__custom_Key_vue___default.a
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['addLayer', 'setKey', 'setBorderColour']), {
    changeUrl: function changeUrl(e) {
      this.tilelayer.setUrl('/static/assets/tiles/' + e + '/{z}/{x}/{y}.png');
      this.setKey(e);
      this.setBorderColour(e);
    }
  })
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Layout__);


var _getters;






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    key: 0,
    keyString: 'Map',

    borderColour: '#afdffd',

    showMarkers: false
  },
  getters: (_getters = {
    key: function key(state) {
      return state.key;
    },
    getKey: function getKey(state) {
      return function (matchKey) {
        return state.key === matchKey;
      };
    },

    keyString: function keyString(state) {
      return state.keyString;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'getKey', function getKey(state) {
    return function (matchKeyString) {
      return state.keyString === matchKeyString;
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'borderColour', function borderColour(state) {
    return state.borderColour;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'getColour', function getColour(state) {
    return function (matchColour) {
      return state.borderColour === matchColour;
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'showMarkers', function showMarkers(state) {
    return state.showMarkers;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'getShowMarkers', function getShowMarkers(state) {
    return function (matchResult) {
      return state.showMarkers === matchResult;
    };
  }), _getters),
  mutations: {
    setKey: function setKey(state, keyString) {
      var newKey = 0,
          string = 'Map';

      if (keyString === 'tree') {
        newKey = 3;
        string = 'Tree';
      } else if (keyString === 'wildflower') {
        newKey = 2;
        string = 'Wildflower';
      } else if (keyString === 'bluebell') {
        newKey = 1;
        string = 'Bluebell';
      }
      state.key = newKey;
      state.keyString = string;
    },
    setBorderColour: function setBorderColour(state, keyString) {
      var newColour = '#afdffd';
      if (keyString === 'tree') {
        newColour = '#8bcc82';
      } else if (keyString === 'wildflower') {
        newColour = '#fddbaf';
      } else if (keyString === 'bluebell') {
        newColour = '#b1a8ea';
      }
      state.borderColour = newColour;
    },
    toggleMarkers: function toggleMarkers(state, current) {
      console.log('changing toggle from ' + current);
      if (current === true) {
        state.showMarkers = false;
      } else {
        state.showMarkers = true;
      }
      console.log('    to ' + current);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].plugin, store);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__Layout___default.a }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMap", function() { return getMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMapById", function() { return getMapById; });
var getMap = function getMap(state) {
  return state.maps[state.mapid];
};
var getMapById = function getMapById(state, id) {
  return state.maps[id];
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(35);




var state = {
  mapid: null,
  maps: {}
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapReady", function() { return mapReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addControl", function() { return addControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeControl", function() { return removeControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLayer", function() { return addLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLayer", function() { return hasLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLayer", function() { return removeLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openPopup", function() { return openPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closePopup", function() { return closePopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openTooltip", function() { return openTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTooltip", function() { return closeTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEvent", function() { return addEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEvent", function() { return removeEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locate", function() { return locate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchMap", function() { return switchMap; });
var mapReady = function mapReady(state, _ref) {
  var name = _ref.name,
      options = _ref.options;

  state.mapid = name;
  state.maps[name] = L.map(name, options);
};

var addControl = function addControl(state, control) {
  return state.maps[state.mapid].addControl(control);
};

var removeControl = function removeControl(state, control) {
  return state.maps[state.mapid].removeControl(control);
};

var addLayer = function addLayer(state, layer) {
  return state.maps[state.mapid].addLayer(layer);
};

var hasLayer = function hasLayer(state, layer) {
  return state.maps[state.mapid].hasLayer(layer);
};

var removeLayer = function removeLayer(state, layer) {
  return state.maps[state.mapid].removeLayer(layer);
};

var openPopup = function openPopup(state, popup) {
  return state.maps[state.mapid].openPopup(popup);
};

var closePopup = function closePopup(state, popup) {
  return state.maps[state.mapid].closePopup(popup);
};

var openTooltip = function openTooltip(state, tooltip) {
  return state.maps[state.mapid].openTooltip(tooltip);
};

var closeTooltip = function closeTooltip(state, tooltip) {
  return state.maps[state.mapid].closeTooltip(tooltip);
};

var addEvent = function addEvent(state, _ref2) {
  var event = _ref2.event,
      func = _ref2.func;
  return state.maps[state.mapid].on(event, func);
};

var removeEvent = function removeEvent(state, _ref3) {
  var event = _ref3.event,
      func = _ref3.func;
  return state.maps[state.mapid].off(event, func);
};

var locate = function locate(state, options) {
  return state.maps[state.mapid].locate(options);
};

var switchMap = function switchMap(state, id) {
  return state.mapid = id;
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  "data-v-47e1d309",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(72)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  "data-v-48c9e322",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  "data-v-a4794974",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  "data-v-06347a8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  "data-v-42086c72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('l-map', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "min-zoom": _vm.minZoom,
      "max-zoom": _vm.maxZoom,
      "attributionControl": _vm.attributionControl,
      "zoomend": _vm.zoomend
    }
  }, [_c('l-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _c('l-marker', {
    attrs: {
      "position": _vm.offMapMarker,
      "title": _vm.title,
      "opacity": _vm.opacity,
      "draggable": _vm.draggable
    }
  }, [_c('l-tooltip', {
    attrs: {
      "content": "find lat lang"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.markers), function(m) {
    return _c('l-marker', {
      attrs: {
        "position": m.coords,
        "title": _vm.title,
        "opacity": _vm.opacity,
        "draggable": false
      }
    }, [_c('l-popup', {
      attrs: {
        "heading": m.heading,
        "content": m.content,
        "link": m.link
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "icon standing-dead"
  }, [_vm._v("Standing dead wood / habitat tree")]), _vm._v(" "), _c('p', {
    staticClass: "icon active"
  }, [_vm._v("Active coppice")]), _vm._v(" "), _c('p', {
    staticClass: "icon notable"
  }, [_vm._v("Notable Tree")]), _vm._v(" "), _c('p', {
    staticClass: "icon possible",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_vm._v("Possible Veteran")]), _vm._v(" "), _c('p', [_vm._v("A.c. field maple (Acer campestre)")]), _vm._v(" "), _c('p', [_vm._v("A.g. alder (Alnus glutinosa)")]), _vm._v(" "), _c('p', [_vm._v("A.h. horse chestnut (Aesculus hippocastanum)")]), _vm._v(" "), _c('p', [_vm._v("A.p. sycamore (Acer pseudoplatanus)")]), _vm._v(" "), _c('p', [_vm._v("A.pl. Norway maple (Acer platanoides)")]), _vm._v(" "), _c('p', [_vm._v("B. spp. downy & silver birches (Betula pubescens &  B. pendula)")]), _vm._v(" "), _c('p', [_vm._v("C.a. hazel (Coryllus avelana)")]), _vm._v(" "), _c('p', [_vm._v("C.b. hornbeam (Carpinus betulus)")]), _vm._v(" "), _c('p', [_vm._v("C.m. hawthorn (Crataegus monogyna)")]), _vm._v(" "), _c('p', [_vm._v("C.s. sweet chestnut (Castanea sativa)")]), _vm._v(" "), _c('p', [_vm._v("F.e. ash (Fraxinus excelsior)")]), _vm._v(" "), _c('p', [_vm._v("F.s. beech (Fagus sylvatica)")]), _vm._v(" "), _c('p', [_vm._v("H.h. ivy (Hedera helix)")]), _vm._v(" "), _c('p', [_vm._v("I.a. holly (Ilex aquifolium)")]), _vm._v(" "), _c('p', [_vm._v("L.d. European larch (Larix decidua)")]), _vm._v(" "), _c('p', [_vm._v("P.a. wild cherry (Prunus avium)")]), _vm._v(" "), _c('p', [_vm._v("P.h. London plane (Platanus hispanica)")]), _vm._v(" "), _c('p', [_vm._v("P.m. Douglas fir (Pseudotsuga menziesii)")]), _vm._v(" "), _c('p', [_vm._v("P.s. Scot’s pine (Pinus sylvestris)")]), _vm._v(" "), _c('p', [_vm._v("Q. spp. English & sessile oaks (Quercus robur & Q. petraea) ")]), _vm._v(" "), _c('p', [_vm._v("S.spp. willows (Salix species)")]), _vm._v(" "), _c('p', [_vm._v("S.a. rowan (Sorbus aucuparia)")]), _vm._v(" "), _c('p', [_vm._v("S.ar. whitebeam (Sorbus aria)")]), _vm._v(" "), _c('p', [_vm._v("S.n. elder (Sambucus nigra)")]), _vm._v(" "), _c('p', [_vm._v("T.spp. lime (Tilia species)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-bottom": "45px"
    }
  }, [_vm._v("T.b. yew (Taxus baccata)")])])
}]}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('l-toggle'), _vm._v(" "), _c('l-key', {
    ref: "theKey"
  }), _vm._v(" "), _c('l-tile-select', {
    ref: "selectTile",
    on: {
      "map": _vm.changeUrl
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("2000 honeysuckle survey")]), _vm._v(" "), _c('p', {
    staticClass: "icon honey"
  }, [_vm._v("honeysuckle (Lonicera periclymenum)")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2001 wildflower survey")]), _vm._v(" "), _c('p', {
    staticClass: "icon anemone"
  }, [_vm._v("wood anemone (Anemome nemorosa)")]), _vm._v(" "), _c('p', {
    staticClass: "icon golden"
  }, [_vm._v("golden saxifrage (Chrysosplenium oppositifolium)")]), _vm._v(" "), _c('p', {
    staticClass: "icon sorrel"
  }, [_vm._v("wood sorrel (Oxalis acetosella)")]), _vm._v(" "), _c('p', {
    staticClass: "icon lesser"
  }, [_vm._v("lesser celandine (Ranunculus ficaria)")])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-info",
    style: ({
      borderColor: _vm.borderColour
    })
  }, [_c('div', {
    staticClass: "controls",
    style: ({
      backgroundColor: _vm.borderColour
    }),
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('p', {
    staticClass: "control-text"
  }, [_vm._v("TOGGLE  KEY  ON / OFF")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.show,
      "leave": _vm.hide
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.borderColour
    })
  }, [_c('span', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.keyString) + " Key")])]), _vm._v(" "), (_vm.key == 0) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('map-key')], 1) : (_vm.key === 1) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('bluebell-key')], 1) : (_vm.key === 2) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('wild-flower-key')], 1) : (_vm.key === 3) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('tree-key')], 1) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("2012 English bluebell survey (Hyacinthoides non-scripta)")]), _vm._v(" "), _c('p', {
    staticClass: "icon under100"
  }, [_vm._v("dominant: 80 -100%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under80"
  }, [_vm._v("abundant: 60 - 80% ")]), _vm._v(" "), _c('p', {
    staticClass: "icon under60"
  }, [_vm._v("frequent: 40 -60%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under40"
  }, [_vm._v("occasional: 20 - 40%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under20"
  }, [_vm._v("rare: 1 - 20%")]), _vm._v(" "), _c('p', {
    staticClass: "icon none"
  }, [_vm._v("not surveyed")])])
}]}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "icon main-path"
  }, [_vm._v("Main footpath")]), _vm._v(" "), _c('p', {
    staticClass: "icon second-path"
  }, [_vm._v("Secondary footpath")]), _vm._v(" "), _c('p', {
    staticClass: "icon desire-line"
  }, [_vm._v("Desire Line")]), _vm._v(" "), _c('p', {
    staticClass: "icon easy-trail"
  }, [_vm._v("Easy going trail (wheelchair accessible)")]), _vm._v(" "), _c('p', {
    staticClass: "icon footbridge"
  }, [_vm._v("Footbridge")]), _vm._v(" "), _c('p', {
    staticClass: "icon info"
  }, [_vm._v("Information board")]), _vm._v(" "), _c('p', {
    staticClass: "icon bench"
  }, [_vm._v("Bench")]), _vm._v(" "), _c('p', {
    staticClass: "icon flush"
  }, [_vm._v("Flush / Saturated soil")])])
}]}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiles-select"
  }, [_c('button', {
    staticClass: "none",
    on: {
      "click": function($event) {
        _vm.change('none')
      }
    }
  }, [_vm._v("Base Map")]), _vm._v(" "), _c('button', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        _vm.change('bluebell')
      }
    }
  }, [_vm._v("Bluebells")]), _vm._v(" "), _c('button', {
    staticClass: "wild",
    on: {
      "click": function($event) {
        _vm.change('wildflower')
      }
    }
  }, [_vm._v("Wild Flowers")]), _vm._v(" "), _c('button', {
    staticClass: "tree",
    on: {
      "click": function($event) {
        _vm.change('tree')
      }
    }
  }, [_vm._v("Trees")])])
},staticRenderFns: []}

/***/ })
],[32]);


// WEBPACK FOOTER //
// static/js/app.8b6554b9afd55df8f2ef.js